// extracted by mini-css-extract-plugin
export default {"page":"c-a_M","page_withoutPaddingTop":"c-a_N","page_withoutGap":"c-a_O","page_withMarginBottom":"c-a_P"};